import { baseUrl } from '@/shared/constants'
import axios from 'axios'

export const getTotalAccountValueData = async () => {
  const response = await axios.get(`${baseUrl}/analytics/account-value-total`, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
  return response.data
}


export const postCountClick = async (token: string, event_name: string) => {
  const response = await axios.post(
    `${baseUrl}/analytics/`,
    {
      event_name: event_name,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  )
  return response.data
}
